import type { ReactNode } from 'react'

import styles from './EmptyState.module.css'

export interface EmptyStateProps {
  /** A 28 px lucide icon for the disc. */
  icon?: ReactNode
  title: ReactNode
  /** What will appear here, v2/Body text-2. */
  body?: ReactNode
  /** The next step — pass `<Button variant="secondary" size="md">`. */
  action?: ReactNode
  className?: string
}

/** v2 Empty State (Figma 43:230): a 72 px icon disc, title, body and an optional button, centred. */
export function EmptyState({ icon, title, body, action, className }: EmptyStateProps): JSX.Element {
  return (
    <div className={[styles.empty, className ?? ''].filter(Boolean).join(' ')}>
      {icon ? (
        <span className={styles.disc} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <p className={styles.title}>{title}</p>
      {body ? <p className={styles.body}>{body}</p> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  )
}
